/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutoIssuedCouponDto } from '../../models/auto-issued-coupon-dto';

export interface AutoIssuedCouponControllerFindById$Params {
  id: string;
}

export function autoIssuedCouponControllerFindById(http: HttpClient, rootUrl: string, params: AutoIssuedCouponControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoIssuedCouponDto>> {
  const rb = new RequestBuilder(rootUrl, autoIssuedCouponControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutoIssuedCouponDto>;
    })
  );
}

autoIssuedCouponControllerFindById.PATH = '/api/auto-issued-coupon/{id}';
